import DataTable from "react-data-table-component";
import { useThemeContext } from "../../../Context/ThemeContext";

const DataTableCommon = ({
  columns,
  data,
  paginationResetDefaultPage,
  subHeaderComponent,
  progressPending,
}) => {
  const { themeContext } = useThemeContext();

  return (
    <DataTable
      columns={columns}
      data={data}
      pagination
      paginationResetDefaultPage={paginationResetDefaultPage}
      highlightOnHover
      subHeader
      subHeaderComponent={subHeaderComponent}
      subHeaderAlign="right"
      persistTableHead
      progressPending={progressPending}
      theme={themeContext}
    />
  );
};

export default DataTableCommon;
